import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './Search.css';
import { Device } from '../../device';

export class Search extends React.Component {

  constructor(props) {
    super(props);
    this.state = { 
      term: '', 
    };
    this.onInputChange = this.onInputChange.bind(this);
    this.submitSearch = this.submitSearch.bind(this);
    this.ref = React.createRef();
  }

  componentDidUpdate() {
    if (this.props.active && !Device.IS_MOBILE) {
      setTimeout(() => { this.ref.current.focus(); }, 100);
    }
  }

  onInputChange(event) {
    this.setState({ term: event.target.value });
  }

  submitSearch() {
    const { onSubmit } = this.props;
    const { term } = this.state;
    onSubmit(term);
    this.setState({ term: '' });
  }

  render() {
    const { term } = this.state;
    return (
      <div className={styles.search}>
        <div
          className="form"
        >
          <div className={styles.field}>
            <label htmlFor="searchfield" className={styles.field_label}>
              <span>Zoeken:</span>
              <input
                type="text"
                value={term}
                onChange={this.onInputChange}
                autoComplete="off"
                onKeyDown={k => {
                  if (k.key === 'Enter') {
                    this.submitSearch();
                  }
                }}
                placeholder={this.props.placeholder}
                className={'searchfield'}
                name="searchfield"
                ref={this.ref} 
              />
            </label>
            <div
              className={styles.search_button}
              onClick={this.submitSearch}
            >
              <FontAwesomeIcon icon={['fas', 'search']} size="lg" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}